/* Skippy, Nov 1 2026: cart-page product rails.
   <gc-rail>: prev/next buttons for a horizontal scroll-snap track.
   <gc-recently-viewed>: renders products the shopper viewed (localStorage 'gc_rv', written on product pages
   by layout/theme.liquid); fetches fresh data from /products/<handle>.js and skips unavailable items. */
(function () {
  function bindRail(root) {
    var track = root.querySelector('.gc-rail__track');
    var prev = root.querySelector('.gc-rail__nav--prev');
    var next = root.querySelector('.gc-rail__nav--next');
    if (!track || !prev || !next) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      var scrollable = max > 0;
      prev.hidden = !scrollable; next.hidden = !scrollable;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' }); }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
    root._gcRailUpdate = update;
  }

  if (!customElements.get('gc-rail')) {
    customElements.define('gc-rail', class extends HTMLElement {
      connectedCallback() { bindRail(this); }
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[0] + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }

  if (!customElements.get('gc-recently-viewed')) {
    customElements.define('gc-recently-viewed', class extends HTMLElement {
      connectedCallback() {
        if (this._started) return; this._started = true;
        var self = this, list;
        try { list = JSON.parse(localStorage.getItem('gc_rv') || '[]'); } catch (e) { list = []; }
        if (!Array.isArray(list) || !list.length) return;
        var limit = parseInt(this.dataset.limit || '8', 10);
        var fmt = this.dataset.moneyFormat;
        Promise.all(list.slice(0, 12).map(function (entry) {
          return fetch('/products/' + encodeURIComponent(entry.h) + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) { return p ? { p: p, np: entry.np } : null; })
            .catch(function () { return null; });
        })).then(function (rows) {
          var html = rows.filter(function (r) { return r && r.p.available && r.p.featured_image; })
            .slice(0, limit)
            .map(function (r) {
              var p = r.p;
              var img = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2');
              img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=600';
              var price = (r.np || !p.price) ? '' : '<span class="gc-card__price">' + esc(formatMoney(p.price, fmt)) + '</span>';
              var vendor = p.vendor ? '<span class="gc-card__vendor">' + esc(p.vendor) + '</span>' : '';
              return '<li class="gc-card"><a href="/products/' + esc(p.handle) + '" class="gc-card__link">' +
                '<span class="gc-card__media"><img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="300" height="300"></span>' +
                '<span class="gc-card__title">' + esc(p.title) + '</span>' + vendor + price + '</a></li>';
            }).join('');
          if (!html) return;
          self.querySelector('.gc-rail__track').innerHTML = html;
          self.hidden = false;
          bindRail(self);
        });
      }
    });
  }
})();
